import type { TOC } from '@ember/component/template-only';
import { concat, hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';
import { eq, notEq } from 'ember-truth-helpers';

import PrismCardCardTitle from './card/card-title.gts';

export type HeaderTitle = WithBoundArgs<
  typeof PrismCardCardTitle,
  'isDisabled' | 'isSecondary'
>;

interface PrismCardSignature {
  Args: {
    contentLayout?: 'noPadding' | 'borderedHeader' | 'padded';
    isParent?: boolean;
    isSecondary?: boolean;
  };
  Blocks: {
    content: [];
    footer: [];
    header: [
      {
        title?: HeaderTitle;
      },
    ];
    headerAfter: [];
  };
  Element: HTMLDivElement;
}

const PrismCard: TOC<PrismCardSignature> = <template>
  <div
    class={{concat
      "prism-card"
      " "
      (if @isSecondary "prism-card--secondary")
      " "
      (if @isParent "prism-card--parent")
    }}
    ...attributes
  >
    {{#if (has-block "header")}}
      <div
        class={{concat
          "prism-card__header"
          " "
          (if (eq @contentLayout "borderedHeader") "prism-card__header--border")
        }}
      >
        <div class="prism-card__header__content">
          {{yield
            (hash title=(component PrismCardCardTitle isSecondary=@isSecondary))
            to="header"
          }}
        </div>

        {{#if (has-block "headerAfter")}}
          <div class="prism-card__header__after">
            {{yield to="headerAfter"}}
          </div>
        {{/if}}
      </div>
    {{/if}}

    <div
      class={{concat
        "prism-card__content"
        " "
        (if
          (notEq @contentLayout "noPadding")
          "prism-card__content--default-padding"
        )
        " "
        (if
          (eq @contentLayout "borderedHeader")
          "prism-card__content--padding-top"
        )
      }}
    >
      {{yield to="content"}}
    </div>

    {{#if (has-block "footer")}}
      <div class="prism-card__footer">
        {{yield to="footer"}}
      </div>
    {{/if}}
  </div>
</template>;

export default PrismCard;
